import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-minimal',
  templateUrl: './minimal.component.html',
  styles: [],
})
export class MinimalComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
